const formsController = function($container) {
  const container = $container || $('@body');
  const $textInput = container.find($('input[type=text]'));
  const $textInputPresent = $textInput.length;

  const init = () => {
    $textInput.each(function(i, e) {
      const $this = $(this);
      $this.attr({ maxlength: 75 });
    });
  };

  if ($textInputPresent) {
    init();
  }
};

export default formsController;
